module.exports = __webpack_public_path__ + "static/img/Gacha18.ccdd961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha18.png
// module id = cj7z
// module chunks = 1